import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongDetailsLessonsListGroup.module.scss";
import {useSongDetailsLessonsListGroupLogic} from "./SongDetailsLessonsListGroup.logic";
import {DisclosureGroup} from "../../../../../../components/common/disclosure-group/DisclosureGroup";
import {
  SongDetailsLessonsListGroupItem
} from "../../components/lessons-list-group-item/SongDetailsLessonsListGroupItem";

export interface ISongDetailsLessonsListGroupProps {
  activeLessonId?: number|string;
  difficultyCategory: string;
}

export const SongDetailsLessonsListGroup: VoidFunctionComponent<ISongDetailsLessonsListGroupProps> = ({difficultyCategory, activeLessonId}) => {
  const {groupTitle, groupCount, groupLessons} = useSongDetailsLessonsListGroupLogic(difficultyCategory);
  if (groupLessons.length === 0) {
    return null;
  }

  return (
    <DisclosureGroup title={groupTitle} secondaryInfo={`${groupCount}`}>
      <ol className={s.lessonListGroup}>
        {groupLessons.map((groupLesson) => <SongDetailsLessonsListGroupItem {...groupLesson} isActive={`${activeLessonId}` === `${groupLesson.id}`} key={`lesson-list-group-${difficultyCategory}-item-${groupLesson.id}`} />)}
      </ol>
    </DisclosureGroup>
  );
}

